import React from 'react';
export const AnonymousIcon = ({ ...props }) => {
  return (
    <svg
      height="24"
      viewBox="0 0 32 32"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M23 26.896c2.664 0 4.832-2.167 4.832-4.831S25.664 17.233 23 17.233c-1.828 0-3.403 1.032-4.224 2.533h-5.553c-.82-1.501-2.395-2.533-4.223-2.533-2.664 0-4.832 2.168-4.832 4.832s2.168 4.83 4.832 4.83 4.831-2.166 4.831-4.83c0-.103-.024-.198-.03-.3h4.397c-.006.102-.03.197-.03.3A4.837 4.837 0 0 0 23 26.895zm0-7.663c1.561 0 2.832 1.27 2.832 2.832s-1.27 2.83-2.832 2.83-2.832-1.269-2.832-2.83 1.27-2.832 2.832-2.832zM9 24.896c-1.562 0-2.832-1.27-2.832-2.831S7.438 19.233 9 19.233s2.831 1.27 2.831 2.832-1.27 2.83-2.831 2.83zM30.274 14.784a52.039 52.039 0 0 0-4.757-1.114L23.98 5.911c-.06-.29-.24-.54-.49-.68a1.03 1.03 0 0 0-.84-.06 18.806 18.806 0 0 1-13.3 0 .967.967 0 0 0-.83.06c-.26.14-.44.39-.5.68l-1.537 7.76a52.048 52.048 0 0 0-4.758 1.113 1 1 0 0 0-.687 1.237c.152.53.706.833 1.237.687a49.898 49.898 0 0 1 27.45 0 1.001 1.001 0 0 0 .549-1.924zM8.587 13.32 9.76 7.431a20.76 20.76 0 0 0 12.48 0l1.17 5.888a51.879 51.879 0 0 0-14.823 0z" />
    </svg>
  );
};
